// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1hsod","icon":"SortAdornment_icon__1U3hm","up":"SortAdornment_up__2qKwm","down":"SortAdornment_down__2cq93","active":"SortAdornment_active__2Mfvp"};